/**
 * Hotels API adapter for web-app
 *
 * Hotels-service endpoints (/hotels/v1/…) go through the AWS API Gateway.
 * Endpoints the hotels service doesn't own (calls, voicemails, extensions)
 * stay on the mango-api transport.
 */
import { getApiInst } from '~/atoms/MangoApi'

import { createHotelsApi } from '@mangovoice/hotels-ui'

import { getGatewayTransport } from './gatewayTransport'

export const hotelsApi = createHotelsApi({
  gatewayTransport: getGatewayTransport(),
  mangoTransport: getApiInst().getHttpTransport(),
})
